import { FEVorvertragsnummer } from '@ps20-frontend/frontend-models';
import { isYoungerThan } from '@ps20-frontend/utils';
import { isAzam } from '@ps20-frontend/shop-integration-redux';
import { Feature, Produktlinienname } from '@ps20/bff-models';
import { selectFeatureToggle } from '@ps20-frontend/selector';
import { IAppState } from '../appState';
import { selectRole } from './transientState.selector';
import { selectSelectedProduktlinie } from './produkt.selector';
import { isProfessionalAthlete } from './personen.selector';

export const selectAngebotsId = (state: IAppState): string => state.angebotsId;
export const selectSelectedProduktName = (state: IAppState): Produktlinienname =>
  selectSelectedProduktlinie(state)?.produktName;
export const selectVpGeburtsdatum = (state: IAppState): string => state.vp.geburtsdatum;
export const selectVertragsBeginnDatum = (state: IAppState): string =>
  state.vertragsoptionen.beginnDatum;

export const selectVorvertragsNummern = (state: IAppState): FEVorvertragsnummer[] => {
  const vorvertragsNummern = state.vertragsoptionen.vorvertragsNummern;
  return vorvertragsNummern || [];
};

export const kusAbsprungAvailable = (state: IAppState): boolean => {
  const produktlinie = selectSelectedProduktlinie(state);
  const index = produktlinie.zusatzoptionen.findIndex(
    item => item.name === 'KINDERINDIVIDUALITAETSSCHUTZ',
  );
  return index > -1 ? !produktlinie.zusatzoptionen[index].isSelected : true;
};

export const kusAbsprungVisible = (state: IAppState): boolean => {
  const isBasisProdukt = selectSelectedProduktName(state) === Produktlinienname.BASIS;
  const isVpYoungerThan82 = isYoungerThan(
    selectVpGeburtsdatum(state),
    selectVertragsBeginnDatum(state),
    82,
  );
  const isAzamRole = isAzam(selectRole(state));

  return !isBasisProdukt && isVpYoungerThan82 && !isAzamRole;
};

export const kus5theSaeuleVisible = (state: IAppState): boolean => {
  const isVpYoungerThan82 = isYoungerThan(
    selectVpGeburtsdatum(state),
    selectVertragsBeginnDatum(state),
    82,
  );
  const isAzamRole = isAzam(selectRole(state));
  const toggleAbsprungKus5thSaeule = selectFeatureToggle(state, Feature.UNFALL_KUS_5TH_SAEULE);
  const isAthlete = isProfessionalAthlete(state);
  return toggleAbsprungKus5thSaeule && isVpYoungerThan82 && !isAzamRole && !isAthlete;
};
